// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OdDY","title":"styles_title__1kq5S"};